import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import {
  IApiResponse,
  IListLocationRequestBody,
  ILocation,
  ILocationListResponse,
  ILocationNameResponse,
} from '../../state/models/location.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly apiUrl = `${environment.locationEndpoint}/api/location`;

  constructor(
    private readonly apiService: ApiService
  ) {}

  getLocations(
    page: number = 1,
    limit: number = 10,
    filter?: IListLocationRequestBody
  ): Promise<ILocationListResponse> {
    return this.apiService.post<ILocationListResponse>(
      `${this.apiUrl}/list?page=${page}&limit=${limit}`, filter
    );
  }

  // searchLocations(
  //   name?: string,
  //   status?: 'Active' | 'Inactive'
  // ): Observable<ILocation[]> {
  //   const params: any = { filter: {} };
  //   if (name) params.filter.location_name = name;
  //   if (status) params.filter.is_active = status;
  //   return from(
  //     this.apiService.post<ILocation[]>(`${this.apiUrl}/list`, { params })
  //   );
  // }

  getLocation(id: number): Observable<IApiResponse<ILocation>> {
    return from(
      this.apiService.get<IApiResponse<ILocation>>(`${this.apiUrl}/${id}`)
    );
  }
  createLocation(
    location: Omit<ILocation, '_id'>
  ): Observable<IApiResponse<ILocation>> {
    return from(
      this.apiService.post<IApiResponse<ILocation>>(`${this.apiUrl}/`, location)
    );
  }

  updateLocation(
    id: number,
    location: Partial<ILocation>
  ): Observable<IApiResponse<ILocation>> {
    return from(
      this.apiService.put<IApiResponse<ILocation>>(
        `${this.apiUrl}/${id}`,
        location
      )
    );
  }

  deleteLocation(id: number): Observable<IApiResponse<ILocation>> {
    return from(
      this.apiService.delete<IApiResponse<ILocation>>(`${this.apiUrl}/${id}`)
    );
  }

  toggleStatus(id: number): Observable<IApiResponse<ILocation>> {
    return from(
      this.apiService.patch<IApiResponse<ILocation>>(`${this.apiUrl}/${id}`, {})
    );
  }

  listLocationName(): Observable<IApiResponse<ILocationNameResponse>> {
    return from(
      this.apiService.get<IApiResponse<ILocationNameResponse>>(
        `${this.apiUrl}/get-locations-list/active`,
        {}
      )
    );
  }

  listAllStatusLocationNames(): Observable<
    IApiResponse<ILocationNameResponse>
  > {
    return from(
      this.apiService.get<IApiResponse<ILocationNameResponse>>(
        `${this.apiUrl}/get-locations-list/all`,
        {}
      )
    );
  }
}
